// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3u5JZ","newExpiryDate":"styles_newExpiryDate__2dJYr","footer":"styles_footer__1trvg"};